import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

// Import auth-context before the router: loading this module registers the API
// client's ID-token getter (see auth-context.tsx), so it must run before any
// route module can fire an authenticated request.
import { AuthProvider } from "~/auth/auth-context";
import { router } from "~/router";

import "~/styles/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
